const resorts = [
  { key: 'wyn', text: 'Wyndham', value: 'wyndham'},
  { key: 'dia', text: 'Diamond', value: 'diamond'},
  { key: 'oth', text: 'Other', value: 'other'}
];

export default resorts;